export default "/assets/images/slide-mini-lg.bf150b2c98dd878f.webp";